<template>
  <div>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('chargeTravailAff.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="checkPermissions(permOrdreTravail.maj)
                      ? genererOrdreTravail() : showPopUp()"
                      :class="{ 'button-access-no-permission'
                      : !checkPermissions(permOrdreTravail.maj) }">
                {{ $t('chargeTravailAff.actions.generer')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages" class="mgt-20px"
                         :error="messages.length > 0"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="messages = []"/>
    <div class="columns mgt-20px">
      <div class="column is-4 pdb-0">
        <div class="no-box-shadow-card card height-80 border-color-select">
          <div class="card-header height-80">
            <div class="imgFaceSansListe mgv-auto" v-if="!afficheurSelect">
              <div class="imgFaceSansListe_logo">
              </div>
            </div>
            <img :src="afficheurInformation.logo"
                 v-else-if="afficheurInformation.logo && afficheurSelect" alt=""
                 class="image is-32x32 mg-auto mgl-20px mgr-20px"/>
            <avatar :username="afficheurInformation.nom" v-else :size="32"
                    class="mg-auto mgl-20px mgr-20px"/>
              <div class="mgv-auto pdr-20px
            is-size-6 has-text-weight-bold height-fit-content has-text-link">
                {{ afficheurInformation.nom }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow pdr-0">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      :disabled="getAllTourneeSemaineSelect.length === 0"
                      @click="checkPermissions(constantes.AFFECTATION.maj)
                      ? updateAffectationVisualisation() : showPopUp()"
                      :class="{ 'button-access-no-permission'
                      : !checkPermissions(constantes.AFFECTATION.maj)
                      || getAllTourneeSemaineSelect.length === 0}">
                {{ $t('chargeTravailAff.actions.affecter')}}
              </button>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="columns">
              <p class="column is-narrow mgt-5px">
                {{ $t('chargeTravailAff.chargeTravailPourPeriode') }}
              </p>
              <b-datepicker :value="dateSelect"
                            show-week-number class="column is-7"
                            :date-formatter="formatageOuputDatepicker"
                            @input="makeNewSearch"
                            icon="calendar-today"
                            nearby-selectable-month-days
                            :editable="true">
              </b-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <button class="button" @click="updateRessourceVisualisation">
            {{ $t('chargeTravailAff.ressources', {
            nbRessources: ressources.length }
          )}}
          </button>
        </div>
        <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <tab-tournee-face-semaine :ref="referenceTable" v-if="anneeSemaine && startArrayRendering"
                              :referenceTable="referenceTable"
                              class="tableWithPerPageSelection"
                              @genererOrdreTravail="genererOrdreTravail"
                              :anneeSemaine="anneeSemaine"
                              :typeDonnee="EXPORT_EXCEL_AFFECTATION_LOGISTIQUE"
                              :disabledSelect="affectationVisualisation"
                              :tabDestinationChargeTravail="true">
    </tab-tournee-face-semaine>
    <div class="ressourceLayout" v-if="ressourceVisualisation">
      <ressourceChargeTravail
        @genererOrdreTravail="genererOrdreTravail"
        @reloadRessource="updateChargeTravail"
        @updateShowLaisserEnPlace="updateShowLaisserEnPlace"
        @updateAfficheurSelect="updateAfficheurSelect"
        @updateNePasAfficherLc="updateNePasAfficherLc"
        :afficheurSelect="afficheurSelect"
        :tourneeSelect="tourneeSelect"
        :nePasAfficherLc="nePasAfficherLc"
        :showLaisserEnPlace="showLaisserEnPlace"
        :nbFaceSansTournee="nbFaceSansTournee"
        :societeActiveId="societeActiveId"
        :anneeSemaine="anneeSemaine === null ? 0 : anneeSemaine"
        @close="ressourceVisualisation = false"
        :ressources="ressources">
      </ressourceChargeTravail>
    </div>
    <div class="affectationLayout" v-if="affectationVisualisation">
      <affectation-charge-travail @close="updateRessourceVisualisation"
                                  @openAffectationPopUp="openAffectationPopUp"
                                  :nbFaceSansTournee="nbFaceSansTournee"
                                  :ressources="ressources">
      </affectation-charge-travail>
    </div>
    <b-modal v-model="popUpAffecter"
             has-modal-card
             class="modal">
      <pop-up-affecter-tournee-face-semaine
        @reloadPage="reloadPage"
        @close="popUpAffecter = false; updateRessourceVisualisation()"
        :message="messagesErreur"
        :anneeSemaine="anneeSemaine"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :error="error"
        @affectation="affecterFromPopUpGestion"
        :info-base-for-affectation="afficheurDateListeForAffectation"/>
    </b-modal>
    <b-modal v-model="popUpAffecterToTournee" has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="$t('chargeTravailAff.popUpAffecter.messHeader')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         :messagesPopup="messagesErreur"
                         :isErrorPopup.sync="error"
                         @no="popUpAffecterToTournee = false; updateRessourceVisualisation()"
                         @yes="affecter">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpDesaffecter" has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="$t('chargeTravailAff.popUpDesaffectation.messHeader')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         @no="popUpDesaffecter = false; updateRessourceVisualisation()"
                         @yes="desaffecter">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import breadcrumb from '@/components/general/breadcrumb';
import { ORDRE_TRAVAIL, AFFECTATION } from '@/configuration/logistique/permissionsLogistiqueConf';
import formatDate from '@/services/general/formatDate';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import ressourceChargeTravail from '@/components/logistique/chargeTravail/affichage/ressource/ressourceChargeTravail';
import tabTourneeFaceSemaine from '@/components/logistique/affectation/tabTourneeFaceSemaine';
import {
  getChargeTravail,
  affecterTourneeAffichage,
  affecterTourneeAffichageFictiveAsync,
} from '@/api/logistique/tourneeFaceSemaine';
import formatageRessourceByAfficheur from '@/services/logistique/chargeTravail/affichage/formatageRessourceListe';
import { addTfsAsync, genererOrdreTravail } from '@/api/logistique/ordreTravailAffichage';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/logistique/chargeTravail/affichage/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageSuccess from '@/services/general/messageSucces';
import popUpAffecterTourneeFaceSemaine from '@/components/logistique/chargeTravail/affichage/affectation/p_affecterTourneeFaceSemaine';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import Avatar from 'vue-avatar';
import getLogo from '@/services/general/getLogo';
import affectationChargeTravail
  from '@/components/logistique/chargeTravail/affichage/affectation/affectationChargeTravail';
import PopUpPrevention from '@/components/general/popUpPrevention';
import formatIsoDate from '@/services/general/formatIsoDate';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/affectationTfs/translator';
import validationAffectationTfs from '@/services/logistique/affectationTfs/validation';
import { SET_DATE_SELECT } from '@/store/modules/logistique/demande-mutation-type';
import * as actionsConf from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import { CATEGORIE_REGROUPEMENT, CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';
import { CATEGORIE_PRODUIT_LOGISTIQUE } from '@/configuration/logistique/demande/demandeConf';
import { REFERENCE_TABLE_LISTE_CHARGE_TRAVAIL } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');
const Demande = createNamespacedHelpers('demande');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      showLaisserEnPlace: false,
      permOrdreTravail: ORDRE_TRAVAIL,
      ressourceVisualisation: true,
      affectationVisualisation: false,
      messages: [],
      ressources: [],
      popUpAffecter: false,
      popUpDesaffecter: false,
      popUpAffecterToTournee: false,
      tfsAAffecterIds: [],
      anneeSemaine: null,
      afficheurSelect: null,
      tourneeSelect: null,
      nbFaceSansTournee: 0,
      messagesErreur: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      typeProduits: [],
      EXPORT_EXCEL_AFFECTATION_LOGISTIQUE: actionsConf.EXPORT_EXCEL_AFFECTATION_LOGISTIQUE,
      constantes: {
        AFFECTATION,
      },
      afficheurInformation: {
        logo: null,
        nom: this.$i18n.t('chargeTravailAff.ressourceAndAffectationInfo.faceNonAffecte'),
      },
      afficheurDateListeForAffectation: null,
      referenceTable: REFERENCE_TABLE_LISTE_CHARGE_TRAVAIL,
      startArrayRendering: false,
    };
  },
  components: {
    breadcrumb,
    ressourceChargeTravail,
    tabTourneeFaceSemaine,
    errorMsgComponent,
    popUpAffecterTourneeFaceSemaine,
    Avatar,
    affectationChargeTravail,
    PopUpPrevention,
    parametrageTable,
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Demande.mapMutations({
      setDateSelect: SET_DATE_SELECT,
    }),
    affecterFromPopUpGestion(info) {
      this.afficheurDateListeForAffectation = cloneDeep(info);
      this.affecter();
    },
    async affecter() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messagesErreur = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.afficheurDateListeForAffectation.tourneeId) {
          await affecterTourneeAffichage({
            tourneeId: this.afficheurDateListeForAffectation.tourneeId,
            tourneeFaceSemaineIds: this.getAllTourneeSemaineSelect,
          });
          messageSuccess(this.$i18n.t('chargeTravailAff.popUpAffecter.messages.success.affecter'));
        } else {
          await affecterTourneeAffichageFictiveAsync({
            tourneeFaceSemaineIds: this.getAllTourneeSemaineSelect,
            dateDepart: formatIsoDate(this.afficheurDateListeForAffectation.date),
            libelleListeAffichage: this.afficheurDateListeForAffectation.tourneeLibelle,
            afficheurId: this.afficheurDateListeForAffectation.afficheurId,
            unOtParFace: this.afficheurDateListeForAffectation.unOtParFace,
            agenceId: this.afficheurDateListeForAffectation.agenceId,
          });
          messageSuccess(this.$i18n.t('chargeTravailAff.popUpAffecter.messages.success.affecterTourneeTemp'));
        }
        if (this.afficheurDateListeForAffectation.otId) {
          await addTfsAsync({
            tfsIds: this.getAllTourneeSemaineSelect,
            otId: this.afficheurDateListeForAffectation.otId,
          });
          messageSuccess(this.$i18n.t('chargeTravailAff.popUpAffecter.messages.success.addToOT'));
        }
        this.popUpAffecter = false;
        this.popUpAffecterToTournee = false;
        loadingComponent.close();
        this.reloadPage();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messagesErreur,
            this.messagesChampsVide, translate);
          validationAffectationTfs(e.response, this.messagesErreur);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    openAffectationPopUp(infoAfficheurSelect) {
      this.error = false;
      this.messagesErreur = [];
      if (infoAfficheurSelect.afficheurId !== 'faceNonAffecte') {
        this.afficheurDateListeForAffectation = cloneDeep(infoAfficheurSelect);
        if (infoAfficheurSelect.afficheurId === 'addAfficheur') {
          this.afficheurDateListeForAffectation.afficheurId = null;
        }
        this.afficheurDateListeForAffectation.unOtParFace = false;
        if (infoAfficheurSelect.tourneeId || infoAfficheurSelect.tourneeLibelle) {
          this.popUpAffecterToTournee = true;
        } else this.popUpAffecter = true;
      } else {
        this.afficheurDateListeForAffectation = null;
        this.popUpDesaffecter = true;
      }
    },
    updateRessourceVisualisation() {
      this.affectationVisualisation = false;
      this.ressourceVisualisation = true;
    },
    updateAffectationVisualisation() {
      this.affectationVisualisation = true;
      this.ressourceVisualisation = false;
    },
    reloadPage() {
      this.popUpAffecter = false;
      this.popUpDesaffecter = false;
      this.updateRessourceVisualisation();
      this.updateAfficheurSelect(null);
      this.critereRecherche.afficheurIds = [];
      this.critereRecherche.sansAfficheur = true;
      this.critereRecherche.avecLaisserEnPlaceVente = false;
      this.showLaisserEnPlace = false;
      this.makeNewSearch(this.dateSelect);
    },
    async genererOrdreTravail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let tfsIds = [];
        this.messages = [];
        this.ressources.forEach((ressource) => {
          ressource.listeAffichage.filter((tournee) => {
            return tournee.ordreTravailId === null;
          }).map(tournee => tournee.ids).forEach((ids) => {
            tfsIds = tfsIds.concat(ids);
          });
        });
        if (tfsIds.length > 0) {
          await genererOrdreTravail({
            anneeSemaine: this.anneeSemaine,
            societeId: this.societeActiveId,
            tfsIds: tfsIds,
          });
          messageSuccess(this.$t('chargeTravailAff.messages.sucess.otCreate'));
          await this.updateChargeTravail();
        } else {
          this.messages.push({ message: 'chargeTravailAff.messages.errors.noOt' });
        }

        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messages = [];
          validation(e.response, this.messages);
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    formatageOuputDatepicker() {
      const semaine = (getAnneeSemaineFromDate(this.dateSelect)).substr(4);
      const dateDebut = moment(this.dateSelect).startOf('week').toDate();
      const dateFin = moment(this.dateSelect).endOf('week').toDate();
      return 'S' + semaine + ' : ' + formatDate(dateDebut) + ' - ' + formatDate(dateFin);
    },
    async makeNewSearch(newDate) {
      this.setDateSelect(newDate);
      this.anneeSemaine = Number(getAnneeSemaineFromDate(newDate));
      await this.getAndFormate();
      await this.$refs[this.referenceTable].recherche();
    },
    updateShowLaisserEnPlace() {
      this.showLaisserEnPlace = !this.showLaisserEnPlace;
      if (this.showLaisserEnPlace) this.critereRecherche.avecLaisserEnPlaceVente = null;
      else this.critereRecherche.avecLaisserEnPlaceVente = false;
      this.recherche();
    },
    async updateAfficheurSelect(afficheurId, tourneeId) {
      if (!tourneeId) {
        this.tourneeSelect = null;
        this.critereRecherche.tourneeId = null;
      }
      if (tourneeId && this.tourneeSelect === tourneeId) return;
      this.afficheurSelect = afficheurId;
      this.tourneeSelect = tourneeId;
      if (!afficheurId) {
        this.afficheurInformation = {
          logo: null,
          nom: this.$i18n.t('chargeTravailAff.ressourceAndAffectationInfo.faceNonAffecte'),
        };
        this.critereRecherche.afficheurIds = [];
        this.critereRecherche.sansAfficheur = true;
        this.critereRecherche.agencesIds = this.agenceActive.map((agence) => agence.agenceId);
      } else {
        const ressource = this.ressources.find((r) => { return r.afficheurId === afficheurId; });
        this.afficheurInformation = {
          logo: await getLogo(afficheurId),
          nom: ressource.afficheur,
        };
        this.critereRecherche.agencesIds = this.user.agences
          .filter((agence) => agence.societeId === this.societeActiveId)
          .map((agence) => agence.agenceId);
        if (tourneeId) {
          this.critereRecherche.tourneeId = tourneeId;
          this.critereRecherche.afficheurIds = [];
        } else {
          this.critereRecherche.afficheurIds = [afficheurId];
        }
        this.critereRecherche.sansAfficheur = false;
      }
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].recherche();
    },
    async updateChargeTravail() {
      const chargeTravailUpdated = await this.getChargeTravailADate();
      this.ressources.forEach((ressource) => {
        ressource.listeAffichage.forEach((affichage) => {
          const otFind = (chargeTravailUpdated.find((ot) => {
            return ot.tourneeId === affichage.tourneeId
              && affichage.ids.includes(ot.tfs[0].id);
          }));
          if (otFind) {
            affichage.ordreTravailId = otFind.ordreTravailId;
            affichage.ordreTravail = {
              code: otFind.ordreTravail?.code,
              etat: otFind.ordreTravail?.etat,
            };
          }
        });
      });
    },
    async getChargeTravailADate() {
      const chargeTravail = (await getChargeTravail({
        anneeSemaine: this.anneeSemaine,
        societeId: this.societeActiveId,
        typeProduits: this.typeProduits,
        agenceIds: this.agenceActive.map((agence) => agence.agenceId),
      })).data.result;
      return chargeTravail;
    },
    async getAndFormate() {
      const chargeTravail = await this.getChargeTravailADate();
      this.ressources = formatageRessourceByAfficheur(chargeTravail);
      const chargeSansAfficheur = chargeTravail
        .filter((c) => { return c.afficheurId === null; });
      this.nbFaceSansTournee = 0;
      chargeSansAfficheur.forEach((c) => {
        this.nbFaceSansTournee += c.tfs.length;
      });
    },
    goFirstPage() {
      if (this.$refs.tableTourneeFaceSemaine) {
        this.$refs.tableTourneeFaceSemaine.setPage(1);
      }
    },
    updateNePasAfficherLc() {
      const nePasAfficherLc = cloneDeep(this.nePasAfficherLc);
      if (nePasAfficherLc) this.typeProduits = [];
      else {
        this.typeProduits = [
          cloneDeep(CATEGORIE_PRODUIT_LOGISTIQUE
            .find(c => c.code === CATEGORIE_REGROUPEMENT).code),
        ];
      }
      this.critereRecherche.typeProduits = cloneDeep(this.typeProduits);
      this.getChargeTravailADate();
      this.recherche();
    },
    async desaffecter() {
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await affecterTourneeAffichage({
          tourneeId: null,
          tourneeFaceSemaineIds: this.getAllTourneeSemaineSelect,
        });
        messageSuccess(this.$i18n.t('chargeTravailAff.popUpAffecter.messages.success.desaffecter'));
        this.reloadPage();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...TourneeFaceSemaine.mapGetters({
      tourneeFaceSemaine: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    ...Demande.mapGetters({
      dateSelect: 'dateSelect',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    nePasAfficherLc() {
      return !(this.typeProduits.length === 0
      || (this.typeProduits
        && this.typeProduits.includes(CATEGORIE_UNITAIRE)));
    },
    getAllTourneeSemaineSelect() {
      return this.tourneeFaceSemaine
        .filter((tournee) => { return tournee.selected; })
        .map(tournee => tournee.id);
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('chargeTravailAff.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('chargeTravailAff.breadcrumb.listeChargeTravail'), route: '', isActive: true },
      ];
      return output;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.reloadPage, this.goFirstPage);
      this.setInformationPage(this.$t('pageLogistique.chargeTravail.listeAff'));
      this.anneeSemaine = Number(getAnneeSemaineFromDate(this.dateSelect));
      this.critereRecherche.avecLaisserEnPlaceVente = false;
      this.critereRecherche.afficheurIds = [];
      this.critereRecherche.sansAfficheur = true;
      await this.getAndFormate();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
};
</script>
